import React from 'react';
import { createRoot } from 'react-dom/client';
import ConfirmDialog, { type ConfirmOptions } from './ConfirmDialog';
import './ConfirmDialog.scss';

/**
 * Ask before doing something that is hard to undo — the page's own dialog in
 * place of the browser's window.confirm (which blocks the tab, cannot be
 * styled and reads "localhost says"). Resolves true when confirmed; leaving
 * the page meanwhile (Back, a swipe) answers "Hủy", so nothing stale runs on
 * the next page.
 *
 *   if (!(await confirmDialog({ title: 'Bỏ bài?', message: '…', confirmLabel: 'Bỏ bài', tone: 'danger' }))) return;
 */
export const confirmDialog = (options: ConfirmOptions): Promise<boolean> => new Promise((resolve) => {
  const host = document.createElement('div');
  document.body.appendChild(host);
  const root = createRoot(host);
  const before = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  const routeWatch = new AbortController();
  let open = true;
  const done = (confirmed: boolean) => {
    if (!open) return;
    open = false;
    routeWatch.abort();
    // Unmounted once the click that answered has finished in this root.
    window.setTimeout(() => {
      root.unmount();
      host.remove();
    }, 0);
    before?.focus();
    resolve(confirmed);
  };
  window.addEventListener('hashchange', () => done(false), { signal: routeWatch.signal });
  window.addEventListener('popstate', () => done(false), { signal: routeWatch.signal });
  root.render(<ConfirmDialog {...options} onDone={done} />);
});
